import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  streamConfigBox: {
    border: '1px solid var(--mui-palette-TableCell-border)',
    borderRadius: '.25rem',
    overflow: 'auto',
    [theme.breakpoints.up('sm')]: {
      height: '12.25rem'
    },
    [theme.breakpoints.up('md')]: {
      height: '12.25rem'
    },
    [theme.breakpoints.up('lg')]: {
      height: '12.05rem'
    },
    [theme.breakpoints.up('xl')]: {
      height: '11.95rem'
    }
  },
  CollapseTableRow: {
    borderTop: `1px solid ${theme.vars.palette.border.main}`,
    td: {
      paddingTop: '0rem',
      paddingBottom: '0rem'
    }
  },
  nestedChild: {
    width: '100%',
    '& .MuiPaper-elevation': {
      backgroundColor: 'var(--mui-palette-background-elevation1)'
    }
  },
  dpTableContainer: {
    maxHeight: 'unset',
    minHeight: 'auto',
    borderRadius: theme.shape.borderRadius
  },
  dpTable: {
    boxShadow: 'none',
    border: `1px solid ${theme.vars.palette.border.light}`
  },
  dsHeaderTableCell1: {
    width: '100%',
    padding: '.5rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.vars.palette.background.elevation0,
    borderBottom: 'none'
  },
  dsHeaderTableCell2: {
    padding: '.5rem',
    textAlign: 'right',
    backgroundColor: theme.vars.palette.background.elevation0,
    borderBottom: 'none'
  }
}));

export default useStyles;
